import React, { useState } from "react";
import "./WhatsAppButton.css";

const WhatsAppButton = () => {
  const [showPopup, setShowPopup] = useState(true);

  const phone = "33603199420";
  const message = encodeURIComponent(
    "Bonjour, je souhaite avoir plus d'informations sur vos services."
  );

  const openWhatsApp = () => {
    window.open(
      `https://wa.me/${phone}?text=${message}`,
      "_blank",
      "noopener,noreferrer"
    );
  };

  return (
    <div className="whatsapp-wrapper">

      {showPopup && (
        <div className="whatsapp-popup">
          <button
            className="whatsapp-close"
            onClick={() => setShowPopup(false)}
            aria-label="Fermer"
          >
            ×
          </button>

          <div>Discutez avec nous</div>
          <div>sur WhatsApp</div>
        </div>
      )}

      <button
        className="whatsapp-button"
        onClick={openWhatsApp}
        aria-label="Contacter GPE sur WhatsApp"
      >
        <svg
          viewBox="0 0 32 32"
          width="34"
          height="34"
          aria-hidden="true"
        >
          <path
            fill="currentColor"
            d="M19.11 17.27c-.29-.15-1.71-.84-1.98-.94-.27-.1-.47-.15-.67.15-.2.29-.76.94-.93 1.13-.17.2-.34.22-.63.07-.29-.15-1.21-.45-2.3-1.43-.85-.76-1.43-1.7-1.6-1.99-.17-.29-.02-.45.13-.6.13-.13.29-.34.44-.51.15-.17.2-.29.29-.49.1-.2.05-.37-.02-.52-.07-.15-.67-1.62-.91-2.22-.24-.58-.48-.5-.67-.51h-.57c-.2 0-.52.07-.79.37-.27.29-1.04 1.02-1.04 2.48 0 1.46 1.06 2.87 1.21 3.07.15.2 2.08 3.18 5.04 4.45.7.3 1.25.48 1.68.62.71.23 1.36.2 1.87.12.57-.08 1.71-.7 1.95-1.38.24-.68.24-1.26.17-1.38-.07-.12-.27-.2-.56-.35Z"
          />
          <path
            fill="currentColor"
            d="M16.02 3.2c-7.06 0-12.8 5.74-12.8 12.8 0 2.26.59 4.38 1.63 6.22L3.1 28.8l6.75-1.7a12.74 12.74 0 0 0 6.17 1.58h.01c7.06 0 12.8-5.74 12.8-12.8S23.08 3.2 16.02 3.2Zm0 23.25h-.01a10.45 10.45 0 0 1-5.33-1.46l-.38-.23-4.01 1.01 1.07-3.91-.25-.4a10.44 10.44 0 1 1 8.91 4.99Z"
          />
        </svg>
      </button>

    </div>
  );
};

export default WhatsAppButton;
